/** Short synthesized cues for the interval timer (no audio assets). */

const MUTE_KEY = "lt_interval_sound_muted";
let ctx = null;

function audioContext() {
  if (typeof window === "undefined") return null;
  const Ctor = window.AudioContext || window.webkitAudioContext;
  if (!Ctor) return null;
  if (!ctx) ctx = new Ctor();
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

export function intervalSoundMuted() {
  try {
    return localStorage.getItem(MUTE_KEY) === "1";
  } catch {
    return false;
  }
}

export function setIntervalSoundMuted(muted) {
  try {
    localStorage.setItem(MUTE_KEY, muted ? "1" : "0");
  } catch {
    /* storage unavailable */
  }
}

function tone(frequency, startOffset, durationSec) {
  const ac = audioContext();
  if (!ac) return;
  const osc = ac.createOscillator();
  const gain = ac.createGain();
  const t0 = ac.currentTime + startOffset;
  osc.type = "sine";
  osc.frequency.value = frequency;
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.exponentialRampToValueAtTime(0.35, t0 + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + durationSec);
  osc.connect(gain).connect(ac.destination);
  osc.start(t0);
  osc.stop(t0 + durationSec + 0.05);
}

/** @param {"tick"|"work"|"rest"|"done"} cue */
export function playIntervalCue(cue) {
  if (intervalSoundMuted()) return;
  try {
    if (cue === "tick") tone(660, 0, 0.12);
    else if (cue === "work") tone(990, 0, 0.45);
    else if (cue === "rest") tone(440, 0, 0.45);
    else if (cue === "done") {
      tone(880, 0, 0.2);
      tone(880, 0.28, 0.2);
      tone(1175, 0.56, 0.5);
    }
  } catch {
    /* audio blocked until user gesture */
  }
}

/** Unlock audio from a click handler (iOS needs a gesture before the first cue). */
export function primeIntervalAudio() {
  audioContext();
}
